// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"8892bc4c","563":"d35a425b","787":"49349b02"}[chunkId] + ".chunk.js";
};